import { render } from "./SettingsTerminal.vue?vue&type=template&id=4b41094c&scoped=true"
import script from "./SettingsTerminal.vue?vue&type=script&lang=js"
export * from "./SettingsTerminal.vue?vue&type=script&lang=js"

import "./SettingsTerminal.vue?vue&type=style&index=0&id=4b41094c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b41094c"]])

export default __exports__